import leftArrowImg from './images/left-arrow.png';
import rightArrowImg from './images/right-arrow.png';
import egiptianTombImg from '../assets/images/egiptianTomb.png';
import roomImg from './images/room.png';
import roomCloserImg from './images/roomCloser.png';
import meImg from './images/PopaBianca-Stefana.png';
import tombAnimationVid from './videos/TombAnimation.mp4';
import duckAnimationVid from './videos/DuckAnimation.mp4';
import spiderAnimationVid from './videos/SpiderAnimation.mp4';
import githubImg from '../assets/images/github-icon.png';
import linkedinImg from '../assets/images/linkedin.png';
import emailImg from '../assets/images/email.png';
import sketchfabImg from '../assets/images/sketchfab.png';
import menuImg from '../assets/images/menu.png';
import arrowDownImg from '../assets/images/arrow-down.png';
import viewModelImg from '../assets/images/3d-view.png';
import armChairImg from '../assets/images/armChair.png';
import sofaImg from '../assets/images/sofa.png';
import cabinetImg from '../assets/images/cabinet.png';
import bedImg from '../assets/images/bed.png';
import sideTableImg from '../assets/images/sideTable.png';
import nightStandImg from '../assets/images/nightStandW.png';
import tabouretImg from '../assets/images/tabouret.png';
import deskImg from '../assets/images/desk.png';
import anubisHeadImg from '../assets/images/anubisHead.png';
import gardeningImg from '../assets/images/gardening.png';
import medicalChatbotImg from '../assets/images/medicalChatbot.png';
import duckImg from '../assets/images/duck.png';
import spiderImg from '../assets/images/spider.png';
import oneLegChairImg from '../assets/images/oneLegChair.png';
import officeChairImg from '../assets/images/officeChair.png';
import coffeeTableImg from '../assets/images/coffeeTable.png';
import mentalVerseImg from '../assets/images/mentalVerse.png';
export interface Asset {
    src: string;
    alt: string;
}

const leftArrow: Asset = { src: leftArrowImg, alt: 'Previous' };
const rightArrow: Asset = { src: rightArrowImg, alt: 'Next' };
const egiptianTomb: Asset = { src: egiptianTombImg, alt: 'Egiptian Tomb' };
const room: Asset = { src: roomImg, alt: 'Room' };
const roomCloser: Asset = { src: roomCloserImg, alt: 'Room Closer' };
const me: Asset = { src: meImg, alt: 'Me' };
const tombAnimation: Asset = { src: tombAnimationVid, alt: 'Tomb Animation' };
const duckAnimation: Asset = { src: duckAnimationVid, alt: 'Duck Animation' };
const spiderAnimation: Asset = { src: spiderAnimationVid, alt: 'Spider Animation' };
const github: Asset = { src: githubImg, alt: 'Github' };
const linkedin: Asset = { src: linkedinImg, alt: 'Linkedin' };
const email: Asset = { src: emailImg, alt: 'Email' };
const sketchfab: Asset = { src: sketchfabImg, alt: 'Sketchfab' };
const menu: Asset = { src: menuImg, alt: 'Menu' };
const arrowDown: Asset = { src: arrowDownImg, alt: 'Arrow Down' };
const viewModel: Asset = { src: viewModelImg, alt: '3D View' };
const armChair: Asset = { src: armChairImg, alt: 'Arm Chair' };
const sofa: Asset = { src: sofaImg, alt: 'Sofa' };
const cabinet: Asset = { src: cabinetImg, alt: 'Cabinet' };
const bed: Asset = { src: bedImg, alt: 'Bed' };
const sideTable: Asset = { src: sideTableImg, alt: 'Side Table' };
const nightStand: Asset = { src: nightStandImg, alt: 'Night Stand' };
const tabouret: Asset = { src: tabouretImg, alt: 'Tabouret' };
const desk: Asset = { src: deskImg, alt: 'Desk' };
const anubisHead: Asset = { src: anubisHeadImg, alt: 'Anubis Head' };
const gardening: Asset = { src: gardeningImg, alt: 'Gardening' };
const medicalChatbot: Asset = { src: medicalChatbotImg, alt: 'Medical Chatbot' };
const duck: Asset = { src: duckImg, alt: 'Duck' };
const spider: Asset = { src: spiderImg, alt: 'Spider' };
const oneLegChair: Asset = { src: oneLegChairImg, alt: 'One Leg Chair' };
const officeChair: Asset = { src: officeChairImg, alt: 'Office Chair' };
const coffeeTable: Asset = { src: coffeeTableImg, alt: 'Coffee Table' };
const mentalVerse: Asset = { src: mentalVerseImg, alt: 'MentalVerse' };

export {
    leftArrow,
    rightArrow,
    egiptianTomb,
    room,
    me,
    roomCloser,
    tombAnimation,
    duckAnimation,
    spiderAnimation,
    github,
    linkedin,
    email,
    sketchfab,
    menu,
    arrowDown,
    viewModel,
    armChair,
    sofa,
    cabinet,
    bed,
    sideTable,
    nightStand,
    tabouret,
    desk,
    anubisHead,
    gardening,
    medicalChatbot,
    duck,
    spider,
    oneLegChair,
    officeChair,
    coffeeTable,
    mentalVerse
};
